<template>
    <div class="modal"
        ref="modalContainer"
        :class="{ 'modal--open': isModalUIOpen }"
        role="dialog"
        :aria-hidden="!isModalUIOpen"
        @keyup.esc="close">
        <transition name="modal" :duration="300"
            @enter="transitionStep1"
            @after-enter="transitionStep2"
            @before-leave="transitionStep3"
            @after-leave="transitionStep2">
            <div v-if="isModalOpen" class="modal__container">
                <div class="modal__inner">
                    <div class="modal__header">
                        <slot name="header"/>
                        <button class="btn btn--text modal__close"  @click="close">
                            <SvgIcon class="icon" type="icon_close_black" />
                        </button>
                    </div>
                    <div class="modal__body">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </transition>
        <button :tabindex="isModalUIOpen ? 0 : -1" aria-hidden="true" class="modal__focusTrap" @keyup.tab="focusList[0] && focusList[0].focus()"> </button>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Modal',
    components: {
        SvgIcon
    },
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isModalOpen: false,
            isModalUIOpen: false,
            lastHoveredElem: null,
            focusList: []
        }
    },
    methods: {
        close() {
            this.isModalOpen = !this.isModalOpen
            this.$emit('close', this.isModalOpen)
        },
        transitionStep1(el) {
            // set the block height at the moment of its appearance
            this.isModalUIOpen = this.isModalOpen
            el.style.transform = 'translate(0, -120%)'
        },

        transitionStep2(el) {
            // remove inline styles from the block after animation of its appearance
            el.style.transform = 'translate(0, 0)'
            this.isModalUIOpen = this.isModalOpen
        },

        transitionStep3(el) {
            // set the block height at the moment of its appearance
            el.style.transform = 'translate(0, -100%)'
        }
    },
    watch: {
        open(newVal) {
            this.isModalOpen = newVal
            setTimeout(() => {
                if (newVal) {
                    this.lastHoveredElem = document.activeElement
                    document.body.style.overflow = 'hidden'
                    this.focusList = this.$refs.modalContainer.querySelectorAll(
                        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                    )
                    if (this.focusList[1]) {
                        this.focusList[1].focus()
                    }
                } else {
                    this.lastHoveredElem.focus()
                    this.lastHoveredElem.scrollIntoView()
                    document.body.style.overflow = 'auto'
                    this.focusList = []
                }
            }, 200)
        }
    }
}
</script>
